/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface PortalMessage
 */
export interface PortalMessage {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    from_me: boolean;
    /**
     * 
     */
    request_item_id: string | null;
    /**
     * 
     */
    in_reply_to_message_id: string | null;
    /**
     * 
     */
    body: string;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    document_ids: Array<string>;
}

/**
 * Check if a given object implements the PortalMessage interface.
 */
export function instanceOfPortalMessage(value: object): value is PortalMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('from_me' in value) || value['from_me'] === undefined) return false;
    if (!('request_item_id' in value) || value['request_item_id'] === undefined) return false;
    if (!('in_reply_to_message_id' in value) || value['in_reply_to_message_id'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('document_ids' in value) || value['document_ids'] === undefined) return false;
    return true;
}

export function PortalMessageFromJSON(json: any): PortalMessage {
    return PortalMessageFromJSONTyped(json, false);
}

export function PortalMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'from_me': json['from_me'],
        'request_item_id': json['request_item_id'],
        'in_reply_to_message_id': json['in_reply_to_message_id'],
        'body': json['body'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'document_ids': json['document_ids'],
    };
}

export function PortalMessageToJSON(json: any): PortalMessage {
    return PortalMessageToJSONTyped(json, false);
}

export function PortalMessageToJSONTyped(value?: PortalMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'from_me': value['from_me'],
        'request_item_id': value['request_item_id'],
        'in_reply_to_message_id': value['in_reply_to_message_id'],
        'body': value['body'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'document_ids': value['document_ids'],
    };
}

